import { render } from "./FollowsList.vue?vue&type=template&id=7481b25b"
import script from "./FollowsList.vue?vue&type=script&lang=js"
export * from "./FollowsList.vue?vue&type=script&lang=js"

import "./FollowsList.vue?vue&type=style&index=0&id=7481b25b&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__